import { doc, getDoc, setDoc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../firebase/config'; // Adjust the path as needed

export const trackSiteVisit = async () => {
  try {
    const visitRef = doc(db, 'siteStats', 'visits');

    const docSnap = await getDoc(visitRef);
    const now = new Date();
    const day = now.toISOString().slice(0, 10);
    const week = `${now.getUTCFullYear()}-W${Math.ceil((now.getUTCDate() + new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)).getUTCDay()) / 7)}`;
    const month = day.slice(0, 7);
    const year = day.slice(0, 4);

    if (docSnap.exists()) {
      const previous = docSnap.data();
      // Increment the count by 1
      await updateDoc(visitRef, {
        count: increment(1),
        daily: previous.dailyPeriod === day ? increment(1) : 1,
        monthly: previous.monthlyPeriod === month ? increment(1) : 1,
        yearly: previous.yearlyPeriod === year ? increment(1) : 1,
        weekly: previous.weeklyPeriod === week ? increment(1) : 1,
        dailyPeriod: day, weeklyPeriod: week, monthlyPeriod: month, yearlyPeriod: year,
      });
    } else {
      // If the document doesn't exist, create it with count = 1
      await setDoc(visitRef, {
        count: 1, daily: 1, weekly: 1, monthly: 1, yearly: 1,
        dailyPeriod: day, weeklyPeriod: week, monthlyPeriod: month, yearlyPeriod: year,
      });
    }
  } catch (error) {
    console.error('Error tracking site visit:', error);
  }
};
